import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Button } from "@/components/ui/button";
import { Wordmark } from "@/components/editorial";

export function NotFoundPage() {
  return (
    <div className="flex min-h-full flex-col bg-background">
      <Seo title="Page introuvable" canonicalPath="/404" noIndex={true} />

      <header className="flex items-center justify-between border-b border-hair px-5 py-5 lg:px-[72px]">
        <Wordmark size="md" />
      </header>

      <main className="flex flex-1 flex-col items-center justify-center px-5 py-24 text-center">
        <p className="mb-4 font-serif text-[80px] font-light leading-none text-ink-20">
          404
        </p>
        <h1 className="mb-4 font-serif text-[28px] font-normal text-foreground">
          Cette page n'existe pas.
        </h1>
        <p className="mb-10 max-w-[380px] text-[14px] leading-relaxed text-ink-50">
          La page que vous cherchez a peut-être été déplacée ou supprimée.
        </p>
        <Button asChild size="lg">
          <Link to="/">
            <ArrowLeft className="mr-2 size-4" />
            Retour à l'accueil
          </Link>
        </Button>
      </main>
    </div>
  );
}
